// /app/brands/:brandId/integrations — back-compat redirect.
//
// Pre-v0.5.45, brand-service's Meta OAuth callback redirected here
// with ?meta_pick=<state>. That URL was always 404 because the v2
// dashboard's cockpit uses ?tab= search params, never a child route.
// v0.5.45 now sends operators to /app/brands/:id?tab=accounts&meta_pick=…
// directly, but old links (browser history, email, etc.) still need
// to land somewhere useful. This route forwards every search param
// through unchanged, plus pins tab=accounts so the picker modal
// mounts.

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/brands/$brandId/integrations")({
  // Preserve every incoming param so meta_pick + meta_error survive.
  validateSearch: (s: Record<string, unknown>) => s,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/app/brands/$brandId",
      params: { brandId: params.brandId },
      search: { ...(search as Record<string, unknown>), tab: "accounts" } as never,
      replace: true,
    });
  },
  // Component never renders — beforeLoad throws redirect first.
  component: () => null,
});
